import React from "react";

export const useCaptureFrame = (remoteRef) => {
  const captureFrame = React.useCallback(() => {
    if (remoteRef.current && remoteRef.current.videoWidth > 0) {
      const canvas = document.createElement("canvas");
      canvas.width = remoteRef.current.videoWidth;
      canvas.height = remoteRef.current.videoHeight;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(remoteRef.current, 0, 0);
      return new Promise((resolve) => {
        canvas.toBlob((blob) => {
          resolve(blob);
        }, "image/jpeg");
      });
    }
    return Promise.resolve(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { captureFrame };
};
